import Cookies from 'js-cookie';
import React from 'react';
import { COOKIE_KEYS } from 'config/cookieConstants';
import { IdcardOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, type MenuProps } from 'antd';
import authStore from 'stores/auth/AuthStore';
import { AppRoutes } from 'routes/AppRoutes';
import { useNavigate } from 'react-router-dom';


const UserHeaderComponent: React.FC = () => {
    const email = Cookies.get(COOKIE_KEYS.EMAIL);
    const selectedCompany = authStore.selectedCompany;
    const navigate = useNavigate();
    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <p onClick={() => navigate(AppRoutes.SELECT_COMPANY)}>
                    Selecionar empresa
                </p>
            ),
        },
        {
            key: '2',
            label: (
                <p onClick={() => authStore.logout()}>
                    Desconectar
                </p>
            ),
        },

    ];

    return (
        <div className='flex-col gap-4'>
            <Dropdown className="flex items-center cursor-pointer" menu={{ items }} placement="bottomLeft" arrow>
                <div className="flex gap-3" onClick={(e) => e.preventDefault()}>
                    <Avatar
                        className='bg-inherit border-gray-500 border-2 text-gray-500'
                        size={40}
                        icon={<IdcardOutlined style={{ fontSize: "24px" }} />}
                    />
                    <div className='flex flex-col justify-center items-start ' style={{ lineHeight: '1.2' }}>
                        <b><h3>{selectedCompany?.features.onScreenName}</h3></b>
                        <span className="dark:text-white">{email}</span>
                    </div>
                </div>
            </Dropdown>
        </div>
    )
};

export default UserHeaderComponent;